import React from "react";
import styles from "./NumberOne.module.scss";

const NumberOne: React.FC = () => (
  <div className={styles.footerNumberOne}>
    <a
      href="https://www.narodnayamarka.ru/laureaty#:~:text=%D0%9C%D0%B0%D1%80%D0%BA%D0%B5%D1%82%D0%BF%D0%BB%D0%B5%D0%B9%D1%81%20%D1%82%D0%BE%D0%B2%D0%B0%D1%80%D0%BE%D0%B2%20%D0%B4%D0%BB%D1%8F%20%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D1%8F"
      rel="nofollow noreferrer"
      target="_blank"
    >
      Марка №1
      <br /> в России® 2022
    </a>
  </div>
);

export default NumberOne;
